import { Typography, Layout } from "antd";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const DeleteAccount = () => {
    return (
        <Layout style={{ backgroundColor: "#f9f9f9", padding: "30px" }}>
            <Content style={{ maxWidth: 600, margin: "auto" }}>
                <Typography>
                    <Title level={2} style={{ color: "#e63946" }}>Delete Your Account</Title>

                    <Paragraph>
                        You can request to delete your account from the <Text strong>Fanzaty</Text> app in the following ways:
                    </Paragraph>

                    <Title level={4}>🔹 Option 1: From Inside the App</Title>
                    <Paragraph>
                        Open the app, go to:
                        <br />
                        <Text strong>Profile → Settings → Delete Account</Text>
                        <br />
                        and follow the on-screen steps.
                    </Paragraph>

                    <Title level={4}>🔹 Option 2: Email Request</Title>
                    <Paragraph>
                        Email us at <a href="Fanzaty@fanzaty.net">Fanzaty@fanzaty.net</a> using the same email you used to register in the app.
                    </Paragraph>

                    <Paragraph>
                        Please include the following in your message:
                        <ul>
                            <li>Your registered email address</li>
                            <li>Your username (optional, if available)</li>
                        </ul>
                    </Paragraph>

                    <Paragraph>
                        We will delete your account and associated data within 7 days of receiving your request.
                    </Paragraph>

                    <Paragraph>
                        <Text strong>App Name:</Text> Fanzaty<br />
                        <Text strong>Developer:</Text> Fanzaty - فانزاتي
                    </Paragraph>
                </Typography>
            </Content>
        </Layout>
    );
};

export default DeleteAccount;
